import * as Api from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useManagedAccountAccessSessionState } from '../../hooks/useManagedAccountAccessSessionState';
import { bs } from '../../styles/styles';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	styles?: StyleDeclarationValue[];
	userSession: Api.UserSessionContext;
	fixed?: boolean;
}
export const CustomerImpersonationWarning: React.FC<IProps> = observer(props => {
	const { className = '', styles = [], userSession, fixed = true } = props;
	const [utcExpire, setUtcExpire] = React.useState<number | null>(null);
	const { isLoading: isManagedAccountAccessLoading, isManagedAccountAccess } = useManagedAccountAccessSessionState();
	const shouldShowCustomerImpersonationWarning =
		userSession?.isCustomerImpersonation && !isManagedAccountAccessLoading && !isManagedAccountAccess;

	React.useEffect(() => {
		const fetchCredential = async () => {
			if (!userSession?.isCustomerImpersonation || isManagedAccountAccess) {
				return;
			}

			const credential = await userSession.webServiceHelper.getCredentialStore().getCredential();
			if (credential && credential.token_type === 'customer_impersonation') {
				setUtcExpire(credential.expires_utc);
			}
		};

		fetchCredential();
	}, [isManagedAccountAccess, userSession, userSession?.isCustomerImpersonation]);

	return shouldShowCustomerImpersonationWarning ? (
		<div
			className={`customer-impersonation-warning ${className} ${css(fixed && bs.fixed, styleSheet.container, ...styles)}`}
		>
			👁 REMINDER: You are on a customer account. Only perform the actions necessary to support them. LOG OUT when
			complete. Session is valid until {new Date(utcExpire).toLocaleString()} 👁
		</div>
	) : null;
});
